<template>
  <div>
    <a-card title="即将到期的任务" class="filter-data">
      <a-table :pagination="pagination" :columns="columns" size="middle" :data-source="done" :loading="loading" row-key="id" />
    </a-card>

    <a-card title="待处理的缺陷" class="filter-data">
      <a-table :pagination="pagination" :columns="columns" size="middle" :data-source="doing" :loading="loading" row-key="id" />
    </a-card>

    <a-card title="需要您审批的流程" class="filter-data">
      <a-table :pagination="pagination" :columns="columns" size="middle" :data-source="not_begin_list" :loading="loading" row-key="id" />
    </a-card>
  </div>
</template>
<script>
import { faultLevels } from '@/utils/dictionary';
import { getDiagramInfo } from '@/api/data/quality';
const columns = [
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
    width: '10%',
    ellipsis: true
  },
  {
    title: '任务名称',
    dataIndex: 'name',
    width: '15%',
    ellipsis: true
  },
  {
    title: '负责人',
    dataIndex: 'user_name',
    width: '8%',
    align: 'center'
  },
  {
    title: '关联需求',
    dataIndex: 'requirement_id',
    width: '8%',
    align: 'center'
  },
  {
    title: '状态',
    width: '5%',
    dataIndex: 'status',
    ellipsis: true
  },
  {
    title: '预估工时',
    width: '5%',
    ellipsis: true,
    dataIndex: 'point'
  },
  {
    title: '迭代',
    key: 'version_name',
    dataIndex: 'version_name',
    width: '15%',
    align: 'center'
  },
  {
    title: '预计开始时间',
    key: 'pre_start_time',
    dataIndex: 'pre_start_time',
    width: '15%',
    ellipsis: true,
    align: 'center'
  },
  {
    title: '预计结束时间',
    key: 'pre_end_time',
    dataIndex: 'pre_end_time',
    align: 'center',
    width: 90
  }
];

export default {
  components: {},
  props: {
    filterForm: {
      type: Object,
      default: () => {
        return {
          version_id: 1,
          user_group: 1
        };
      }
    }
  },
  data() {
    return {
      loading: false,
      expand: false,
      faultLevels,
      not_begin_list: [],
      doing: [],
      done: [],
      projects: [],
      tagData: [],
      pagination: {
        size: 'large',
        total: 0,
        pageSize: 10, // 每页中显示10条数据
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'], // 每页中显示的数据
        showTotal: total => `共 ${total} 条` // 分页中显示总的数据
      },
      faultInfo: {},
      modalVisible: false,
      faultId: null,
      tableData: [],
      columns
    };
  },
  computed: {},
  mounted() {
    this.getDiagramData();
  },
  methods: {
    getDiagramData() {
      getDiagramInfo(this.filterForm).then(res => {
        this.not_begin_list = res.data.not_begin;
        this.done = res.data.done;
        this.doing = res.data.doing;
      });
    },

    onDetail(record) {
      this.$router.push({
        name: 'page:event:fault:detail',
        query: {
          faultId: record.id
        }
      });
    },

    toggle() {
      this.expand = !this.expand;
    },

    reset() {
      this.filterForm = {
        version_id: 1,
        user_group: 1
      };
      this.getDiagramData();
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .customer-filter {
  .ant-page-header {
    padding: 0;
  }
  margin-bottom: 16px;
  .ant-form-item {
    margin-bottom: 8px;
    display: flex;
    .ant-form-item-control-wrapper {
      flex: 1;
    }
  }
  .filter-right {
    float: right;
    text-align: right;
  }
}
.custom-link {
  color: rgba(0, 0, 0, 0.65);
}
.custom-link:hover {
  color: #1890ff;
}
</style>
